import React from 'react';
import {Carousel as ResponsiveCarousel} from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import IconLeft from '../components/icon/IconLeft';
import IconRight from '../components/icon/IconRight';

export default function Carousel({children}: React.PropsWithChildren<any>) {
  const renderArrowPrev = (clickHandler: () => void, hasNext: boolean) => (
    <>
      {hasNext &&
      <button className="rounded-3xl border border-gray fixed w-10 h-10 z-10 bg-white top-1/2 -ml-3"
        onClick={clickHandler}><IconLeft className="ml-1"/></button>
      }
    </>
  );
  const renderArrowNext = (clickHandler: () => void, hasNext: boolean) => (
    <>
      {hasNext &&
      <button className="rounded-3xl border border-gray fixed w-10 h-10 z-10 bg-white top-1/2 -right-1 mr-3"
        onClick={clickHandler}><IconRight className="ml-2"/></button>
      }
    </>
  );
  return (
    <ResponsiveCarousel showThumbs={false} showIndicators={false} showStatus={false} renderArrowPrev={renderArrowPrev}
      renderArrowNext={renderArrowNext}>
      {children}
    </ResponsiveCarousel>
  );
}
